import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';

const colors = {
  labelColor: '#B3B3B3',
  lineColor: '#EAECEE',
  pointHoverColor: 'rgb(230, 110, 0)',
  makerColor: '#E66400',
  makerFillColor: '#FFFFFF',
  seriesColor: '#009AD9',
  adgroupCurrentPointColor: '#606060',
  markerPointColor: '#aaff99',
};

function getSlideChartOptions(clickGraph) {
  return {
    series: { animation: false },
    chart: {
      type: 'line',
      animation: false,
    },
    title: { text: null },
    xAxis: {
      allowDecimals: !clickGraph,
      labels: {
        enabled: true,
        align: 'left',
        y: 20,
        style: {
          color: colors.labelColor,
          fontWeight: 'bold',
          fontSize: '12px',
        },
        formatter() {
          return clickGraph ? decimalNumber.fromFloatToString(this.value, 0) : decimalNumber.fromFloatToString(this.value, 2); // eslint-disable-line
        },
      },
      title: { text: null },
      categories: null,
      showGridlines: true,
      gridLineWidth: 1,
      gridLineColor: colors.lineColor,
      lineWidth: 1,
      lineColor: colors.lineColor,
      startOnTick: true,
      endOnTick: true,
      tickPositioner() {
        let positions = [],
          tick = this.dataMin, // eslint-disable-line
          increment = (this.dataMax - this.dataMin) / 3; // eslint-disable-line

        positions.push(this.dataMin); // eslint-disable-line
        for (let i = 1; i <= 2; i++) {
          tick += increment;
          positions.push(clickGraph ? Math.ceil(tick) : Math.ceil(tick * 100) / 100);
        }

        positions.push(clickGraph ? Math.ceil(this.dataMax) : Math.ceil(this.dataMax * 100) / 100); // eslint-disable-line
        return positions;
      },
    },
    yAxis: {
      allowDecimals: clickGraph,
      opposite: true,
      title: { text: null },
      tickPositioner() {
        let positions = [],
          increment = (this.dataMax - this.dataMin) / 2; // eslint-disable-line

        positions.push(this.dataMin); // eslint-disable-line

        positions.push(clickGraph ? Math.ceil((this.dataMin + increment) * 100) / 100 : Math.ceil(this.dataMin + increment)); // eslint-disable-line
        positions.push(clickGraph ? Math.ceil(this.dataMax * 100) / 100 : Math.ceil(this.dataMax)); // eslint-disable-line
        return positions;
      },
      labels: {
        enabled: true,
        step: 2,
        formatter() {
          return clickGraph ? decimalNumber.fromFloatToString(this.value, 2) : decimalNumber.fromFloatToString(this.value, 0); // eslint-disable-line
        },
        style: {
          color: colors.labelColor,
          fontWeight: 'bold',
          fontSize: '12px',
        },
        align: 'left',
      },
      showGridlines: true,
      gridLineWidth: 1,
      gridLineColor: colors.lineColor,
      lineWidth: 1,
      lineColor: colors.lineColor,
      startOnTick: true,
      endOnTick: false,
    },
    legend: { enabled: false },
    credits: { enabled: false },   ////get rid of hightcharts.com
    tooltip: {
      enabled: false,
      crosshairs: {
        enabled: true,
        color: '#E66400',
        dashStyle: 'longdash',
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false,
        },
        marker: {
          enabled: true,
        },
        enableMouseTracking: true,
      },
      series: {
        animation: false,
        grouping: false,
        shadow: false,
        marker: {
          fillColor: colors.makerColor,
          radius: 3,
          lineWidth: 1,
          lineColor: colors.makerColor,
          states: {
            hover: {
              radius: 4.5,
            },
          },
        },
        color: colors.seriesColor,
        borderWidth: 0,
        pointWidth: 1,
        lineWidth: 2,
        states: {
          hover: {
            color: colors.pointHoverColor,
          },
        },
        point: { events: {} },
      },
    },
  };
}

function getBidlandscapeChartOptions(isClickGraph) {
  return getSlideChartOptions(isClickGraph);
}

function getAdgroupCurrentPointSetting() {
  return {
    color: colors.markerPointColor,
    marker: {
      enable: true,
      symbol: 'circle',
      radius: 4.5,
      lineWidth: 1,
      lineColor: colors.adgroupCurrentPointColor,
      fillColor: colors.adgroupCurrentPointColor,
    },
  };
}

function getMakerSetting() {
  return {
    marker: {
      enable: true,
      radius: 4.5,
      lineWidth: 1,
      lineColor: colors.makerColor,
      fillColor: colors.makerFillColor,
    },
    color: colors.markerPointColor,
  };
}

export default {
  getBidlandscapeChartOptions,
  getMakerSetting,
  getAdgroupCurrentPointSetting,
};
